import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import type { UserProfileResponse } from '../models';
import { UserProfileApi } from '../apis';

/**
 * UserProfileService
 *
 * Service layer that wraps UserProfileApi.
 *
 * Keeps the store free of direct HTTP concerns.
 *
 * Architecture: Component → Store → Service → Api → Backend
 */
@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private readonly userProfileApi = inject(UserProfileApi);

  /** Fetch the merchant user profile. */
  getUserProfile(): Observable<UserProfileResponse> {
    return this.userProfileApi.getUserProfile();
  }
}
